<div class="column-dialog">
  <h1 mat-dialog-title>{{ 'DataTable.Columns.Customize' | translate:locale.language }}</h1>
  <div mat-dialog-content>
    <p id="selectedColumnsLabel"><strong>{{ 'DataTable.Columns.Selected' | translate:locale.language }}</strong></p>
    <mat-selection-list cdkDropList (cdkDropListDropped)="dropSelectedColumn($event)"
      [cdkDropListData]="data.displayedColumns" *ngIf="data?.displayedColumns"
      [(ngModel)]="data.displayedColumns" aria-labelledby="selectedColumnsLabel">
      <div *ngFor="let column of data.displayedColumns" cdkDrag>
        <mat-list-option #colOption [value]="column" [disabled]="isLocked(column)"
          [attr.data-test]="'columns-selected-' + column">
          <mat-icon matListItemIcon>drag_handle</mat-icon>
          <div matListItemTitle>
            {{ getName(column) | translate:locale.language }}
            <ng-container *ngIf="colOption.disabled">({{ 'required' | translate:locale.language }})</ng-container>
            <div *cdkDragPreview class="drag-item">{{ getName(column) | translate:locale.language }}</div>
          </div>
        </mat-list-option>
      </div>
    </mat-selection-list>
    <p id="availableColumnsLabel"><strong>{{ 'DataTable.Columns.Available' | translate:locale.language }}</strong></p>
    <mat-selection-list *ngIf="filteredAvailableColumns" (selectionChange)="onColumnSelected($event)" aria-labelledby="availableColumnsLabel">
      <mat-list-option [disabled]="column.locked" *ngFor="let column of filteredAvailableColumns"
        [selected]="isSelected(column)" [value]="column" [attr.data-test]="'columns-available-' + column.field">
        <div matListItemTitle>
          {{ column.localizationKey ?? column.field | translate:locale.language }}
          <ng-container *ngIf="column.locked">({{ 'required' | translate:locale.language }})</ng-container>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </div>
  <div mat-dialog-actions class="button-row right">
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate:locale.language }}</button>
    <ng-container *ngIf="data">
      <button mat-button [mat-dialog-close]="data.displayedColumns" cdkFocusInitial>{{ 'OK' |
        translate:locale.language }}</button>
    </ng-container>
  </div>
</div>